import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';

const ACE_ICON_PATH =
  'M908.79 0c-14.97,11.3 -158.15,227.79 -183.45,263.34 -182.61,256.49 -223.66,297.76 -394.9,501.29l-59.09 56.93c-10.75,10.61 -14.89,18.51 -25.67,29.49 -60.44,61.53 -71.52,66.87 -136.46,140.27 -67.39,76.16 -121.19,201.15 -106.91,339.38 7.24,70.01 24.4,117.25 53.1,173.65 37.62,73.91 60.58,85.23 96.29,125.39 37.14,41.76 81.32,67.74 136.95,90.29 117.4,47.57 256.49,47.49 372.62,-4.87 28.45,-12.82 47.46,-22.68 72.13,-38.69 19.08,-12.39 44.33,-35.05 62.05,-43.18 -2.75,106.05 -136.51,324.03 -210.91,414.1l-71.22 83.38c-6.45,7.26 -6.55,6.86 -13.81,13.97l-6.27 6.2c-0.75,0.75 -2.64,4.41 -3.18,3.41 -0.56,-1.02 -2.23,2.27 -3.22,3.51l843.65 -0.19c-0.98,-1.21 -2.45,-2.62 -3.2,-3.41l-97.01 -109.63c-72.56,-88.99 -205.84,-306.31 -208.25,-411.53 31.46,15.53 57.2,47.99 137.95,83.95 116.08,51.68 259.38,49.95 376.69,-0.31 26.68,-11.43 50.33,-24.47 72.58,-38.33 42.04,-26.17 34.36,-26.99 59.11,-51.74 85.87,-85.87 133.31,-167.2 146.88,-300.36 20.22,-198.34 -92.73,-339 -220.64,-453.7 -60.68,-54.41 -133.9,-140.09 -189.89,-202.58 -91.65,-102.29 -243.65,-307.12 -314.9,-409.69l-181.02 -260.34z';

type AceIconProps = {
  className?: string;
};

/** Ícone Ace (espada) — SVG inline; mesmo desenho de `/icons/ace.svg`. */
export function AceIcon({ className }: AceIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1817.6 2157.86"
      className={cn('shrink-0', className)}
      aria-hidden
    >
      <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d={ACE_ICON_PATH} />
    </svg>
  );
}

/** Variante compatível com `LucideIcon` (nav e listagens do painel). */
export const AceNavIcon = AceIcon as LucideIcon;
